const TODO_API_ROOT = '/ows/todo/api/v1';

const TODO_API_TASK = '/tasks/{0}';
const TODO_API_TASKFOLDERS = '/taskfolders';
const TODO_API_TASKS_IN_FOLDER = '/taskfolders/{0}/tasks';
const ACTIVE_FILTER = "$filter=Status ne 'Completed'";
const NOT_STARTED_FILTER = "$filter=Status eq 'NotStarted'";
const COMPLETED_FILTER = "$filter=Status eq 'Completed'";
const ORDER_BY_ORDERDATETIME = '$orderby=OrderDateTime/DateTime desc';
const ORDER_BY_COMPLETEDDATETIME = '$orderby=CompletedDateTime/DateTime desc';
const MAXITEMS_QUERYPARAM_FORMATSTRING = 'maxpagesize={1}'; // VSO: 36993 to switch to $top when available
const EXPAND_LINKED_ENTITIES = '$expand=LinkedEntities';
const TODO_API_ACTIVE_TASKS_QUERYPARAMS =
    '/?' + ACTIVE_FILTER + '&' + ORDER_BY_ORDERDATETIME + '&' + EXPAND_LINKED_ENTITIES;
const TODO_API_DEFAULT_TASKS_QUERYPARAMS = '/?' + NOT_STARTED_FILTER + '&' + EXPAND_LINKED_ENTITIES;
const TODO_API_COMPLETED_TASKS_QUERYPARAMS_FORMAT =
    '/?' +
    COMPLETED_FILTER +
    '&' +
    ORDER_BY_COMPLETEDDATETIME +
    '&' +
    MAXITEMS_QUERYPARAM_FORMATSTRING +
    '&' +
    EXPAND_LINKED_ENTITIES;
export const TODO_API_DEFAULT_FOLDER = 'tasks';
export const TODO_API_GET_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_DELETE_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_UPDATE_TASK_FORMAT = TODO_API_ROOT + TODO_API_TASK;
export const TODO_API_GET_LISTS = TODO_API_ROOT + TODO_API_TASKFOLDERS;
export const TODO_API_CREATE_TASK_IN_FOLDER_FORMAT = TODO_API_ROOT + TODO_API_TASKS_IN_FOLDER;
export const TODO_API_GET_TASKS_IN_FOLDER_FORMAT =
    TODO_API_ROOT + TODO_API_TASKS_IN_FOLDER + TODO_API_ACTIVE_TASKS_QUERYPARAMS;
export const TODO_API_GET_TASKS_IN_DEFAULT_FOLDER_URL =
    TODO_API_ROOT + TODO_API_TASKS_IN_FOLDER + TODO_API_DEFAULT_TASKS_QUERYPARAMS;
export const TODO_API_GET_COMPLETED_TASKS_IN_FOLDER_FORMAT =
    TODO_API_ROOT + TODO_API_TASKS_IN_FOLDER + TODO_API_COMPLETED_TASKS_QUERYPARAMS_FORMAT;
